module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4d0fe43ca32b2e96afca682909802332.png";